// Text statistics and case transforms for the text tool.

const WORDS_PER_MINUTE = 200;

/** Counts words, sentences and paragraphs the way a writer would count them. */
export const textStats = (input) => {
  const text = String(input || '');
  const trimmed = text.trim();

  const words = trimmed ? trimmed.split(/\s+/).filter(Boolean) : [];
  // A sentence ends at . ! ? … — trailing fragments without punctuation still count.
  const sentences = trimmed ? trimmed.split(/[.!?…]+(?:\s|$)/).filter((s) => s.trim()) : [];
  const paragraphs = trimmed ? trimmed.split(/\n\s*\n/).filter((p) => p.trim()) : [];

  return {
    chars: text.length,
    charsNoSpaces: text.replace(/\s/g, '').length,
    words: words.length,
    sentences: sentences.length,
    paragraphs: paragraphs.length,
    lines: text ? text.split('\n').length : 0,
    longestWord: words.reduce((longest, word) => (word.length > longest.length ? word : longest), ''),
    readingMinutes: Math.max(words.length ? 1 : 0, Math.ceil(words.length / WORDS_PER_MINUTE)),
  };
};

const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

export const TRANSFORMS = {
  upper: (text) => text.toUpperCase(),
  lower: (text) => text.toLowerCase(),
  title: (text) => text.replace(/\S+/g, capitalize),
  sentence: (text) => text.toLowerCase().replace(/(^\s*\w|[.!?…]\s+\w)/g, (m) => m.toUpperCase()),
  // Collapses runs of spaces and strips trailing whitespace, keeping line breaks.
  trim: (text) => text.replace(/[^\S\n]+/g, ' ').replace(/ *\n */g, '\n').trim(),
};

export const transformText = (text, kind) => {
  const transform = TRANSFORMS[kind];
  return transform ? transform(String(text || '')) : text;
};
